import { render, staticRenderFns } from "./AddClientFormal.vue?vue&type=template&id=59db613c&scoped=true&"
import script from "./AddClientFormal.vue?vue&type=script&lang=js&"
export * from "./AddClientFormal.vue?vue&type=script&lang=js&"
import style0 from "./AddClientFormal.vue?vue&type=style&index=0&id=59db613c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db613c",
  null
  
)

export default component.exports